import { combineReducers } from 'redux';
import * as fromFullname from './fullname';
import * as fromPassword from './password';
import * as fromDetails from './details';
import * as fromAddress from './address';
import * as gp from './gp';

const {
  firstName,
  surname,
  hasMarketingConsent,
  firstNameError,
  surnameError,
  ...fullnameSel
} = fromFullname;
const {
  password,
  passwordError,
  confirmPassword,
  confirmPasswordError,
  ...passwordSel
} = fromPassword;
const { address, addressErrors, ...addressSel } = fromAddress;
const { phoneNumber, DOB, phoneNumberError, DOBError, ...detailsSel } = fromDetails;
const { gpError, gpId, ...gpSel } = gp;

export const selectors = { ...fullnameSel, ...passwordSel, ...detailsSel, ...addressSel, ...gpSel };

export default combineReducers({
  firstName,
  surname,
  address,
  hasMarketingConsent,
  firstNameError,
  surnameError,
  addressErrors,
  gpId,
  gpError,
  phoneNumber,
  DOB,
  phoneNumberError,
  DOBError,
  password,
  passwordError,
  confirmPassword,
  confirmPasswordError,
});
